import * as React from "react";
import { CheckboxEditor } from "../../../../../../../react-core/Html/CheckboxEditor";
import { SelectEditor } from "../../../../../../../react-core/Html/SelectEditor";
import { TextBoxEditor } from "../../../../../../../react-core/Html/TextBoxEditor";
import { BankAccountOwnerMap } from "../../../NewBusinessWizard/Resource/Contents";
import { ValidatorContents } from "../../../../../Common/ValidatorHelper";
import { Numeric6, Numeric, Name50, AlphanumericWithSpecialCharacters } from "../../../../../../../react-core/Html/Validation/RegExPatterns";
import { BankAccount as BankAccountModel } from "../../../../../../../Wrap/Models/Domains/BankAccount/BankAccount";

interface IBankAccountProps {
    data: BankAccountModel;
}

export const BankAccount = (props: IBankAccountProps) => {
    const { data } = props;
    return (
        <>
            <h4>Bank account details</h4>
            <SelectEditor
                disabled={true}
                options={[data?.Owner]}
                getText={(v) => BankAccountOwnerMap[v]}
                required="Please select Owner"
                selected={data?.Owner}
                label="Owner"
                onChange={() => {}}
            />
            <TextBoxEditor
                disabled={true}
                label="Account Name"
                required="Please enter Account Name"
                value={data?.AccountName}
                maxLength={45}
                regex={{
                    errorMessage: ValidatorContents.AlphaNumericWithSpecialCharacters,
                    value: AlphanumericWithSpecialCharacters,
                }}
                onChange={() => {}}
            />
            <TextBoxEditor
                disabled={true}
                label="Account Number"
                required="Please enter Account Number"
                value={data?.AccountNumber}
                maxLength={8}
                regex={{ errorMessage: "Please enter digits", value: Numeric }}
            />
            <TextBoxEditor
                disabled={true}
                label="Sort Code"
                value={data?.SortCode}
                required={true ? null : "Please enter Sort Code"}
                regex={{ errorMessage: "Please enter 6 digits", value: Numeric6 }}
            />
            <TextBoxEditor disabled={true} label="Building society roll number (optional)" value={data?.RollNumber} />
            <CheckboxEditor
                disabled={true}
                value={data?.NominatedForDirectDebit || false}
                label="Direct Debit instruction"
                cssWrapper="square-checkbox block"
            />
            <CheckboxEditor
                disabled={true}
                value={data?.NominatedForWithdrawal || false}
                label="Nominated account for withdrawals"
                cssWrapper="square-checkbox block"
            />
        </>
    );
};
